import React from "react"
import Testimonial, { Testinomial } from "./Testimonial"

import SarahPark from "../images/SarahPark.png"

const TESTIMONIALS: Testinomial[] = [
  {
    name: "Sarah Park",
    description: "Head of People at Geneva",
    content:
      "A lot of tools have tried to create the energy that Thursday has, but I don't think that anyone has come close to what Thursday is doing.",
    pic: SarahPark,
  },
]

const Testimonials = () => {
  return (
    <div className="testimonials-container">
      {TESTIMONIALS.map((testimonial, index) => (
        <Testimonial
          key={index}
          name={testimonial.name}
          description={testimonial.description}
          content={testimonial.content}
          pic={testimonial.pic}
        />
      ))}
    </div>
  )
}

export default Testimonials
